<template>
  <v-form ref="form">
    <v-flex xs12>
      <h2>Add a Youtrack provider</h2>
      <v-text-field v-model="provlabel" label="Provider name (label)"></v-text-field>
      <v-text-field v-model="provUrl" label="Issue URL pattern"></v-text-field>
      <p class="desc">Provee la url con el formato que tiene la URL de un issue para poder enlazarlo en el listado del tiem tracks disponibles.
        Es necesario que en la url pongas el placeholder <strong>:issueId</strong> el lugar donde va el issue id. Ej: <i>http://pm.front.id/issue/<strong>:issueId</strong></i></p>
      <v-text-field v-model="provApiUrl" label="API URL"></v-text-field>
      <v-text-field v-model="provApiKey" label="API key"></v-text-field>
      <v-text-field v-model="provUser" label="User"></v-text-field>
    </v-flex>

    <v-flex xs12>
      <v-btn color="info" @click="save">Save</v-btn>
    </v-flex>
  </v-form>
</template>

<script>
import { mapState } from "vuex"
import rest from '@/plugins/rest'

export default {
  data() {
    return {
      provlabel: '',
      provUrl: '',
      provApiUrl: '',
      provApiKey: '',
      provUser: '',
    }
  },

  methods: {

    save() {
      const data = {
        type: 'youtrack',
        label: this.provlabel,
        url: this.provUrl,
        credentials: {
          apiUrl: this.provApiUrl,
          apiKey: this.provApiKey,
          user: this.provUser,
        }
      };

      rest.addProvider(data).then(r => {
        console.log(r);
      })
    },
  },

  computed: {
    ...mapState([
      'currentUser',
    ]),
  },

}
</script>
